module.exports = __webpack_public_path__ + "img/vp02.299deff4.jpg";